import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Fallback dashboard for a signed-in user who is none of SystemAdmin, InstitutionAdmin,
 * InstitutionManager, Accountant, StoreAdmin or StoreManager (e.g. SalesRep, or a plain User).
 *
 * The parent's version of this screen called the institution/attendance "my dashboard" summary,
 * which does not exist in this product — attendance and leave were carved out. There is no
 * personal-summary endpoint for these roles yet, so this is a minimal placeholder rather than a
 * screen wired to data that isn't there.
 */
const UserDashboardView: React.FC = () => {
    return (
        <Box sx={{ p: 2 }}>
            <Typography variant="h5" fontWeight="bold" gutterBottom>
                Dashboard
            </Typography>
            <Typography variant="body1" color="text.secondary">
                Welcome. Use the sidebar to get to what you need.
            </Typography>
        </Box>
    );
};

export default UserDashboardView;
